<template>
  <VHover
    v-slot:default="{ hover }"
    class="office-photo-item"
  >
    <VSheet
      :elevation="hover ? 5 : 2"
    >
      <VImg
        :src="photo.preview.url"
        :width="167"
        :height="100"
        @load="$emit('load')"
      />
    </VSheet>
  </VHover>
</template>

<script>
export default {
  name: 'AppPhotoGalleryItem',
  props: {
    photo: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
  .office-photo-item {
    cursor: pointer;

    &::v-deep {
      .v-image {
        border-radius: 4px;
      }
    }
  }
</style>
